import React from 'react';
import { connect } from 'react-redux';
import ProductsShortcuts from './ProductsShortcuts';
import Spinner from 'ui/Spinner';
import Headline from 'ui/Headline';
import Toolbar from 'ui/Toolbar';
import Wrapper from 'ui/Wrapper';
import FlexWrapper from 'ui/FlexWrapper';
import Arrow from 'ui/Arrow';
import { setProductShortcut } from 'features/AISDataProvider/actions';
import { getShortcutProducts } from 'common/selectors/productSelector';
import getTexts from 'utils/localization';
import { fetchRaceDayCalendar } from 'features/AISDataProvider/actions';
import { withRouter } from 'react-router';
import { history } from 'utils/navigation';
const t = getTexts();

class ProductsShortcutsContainer extends React.Component {
    onProductSelectedHandler = (product) => {
        if (!['/', '/hjem'].includes(history.location.pathname)) {
            this.props.history.push('/');
        }
        this.props.setProductShortcut(product);
        this.props.hideModal && this.props.hideModal('PRODUCTS_SHORTCUTS');
        this.props.disappear && this.props.disappear();
    };

    componentDidMount() {
        if (!this.props.ready) {
            this.props.fetchRaceDayCalendar(true);
        }
    }

    render() {
        if (this.props.ready) {
            return (
                <Wrapper padding="0">
                    {!this.props.noTopbar && (
                        <Toolbar
                            secondary
                            left={
                                <FlexWrapper padding="0px">
                                    <Arrow
                                        onClick={() => {
                                            this.props.modalData &&
                                                this.props.modalData.onClose &&
                                                this.props.modalData.onClose();

                                            this.props.hideModal(
                                                'PRODUCTS_SHORTCUTS'
                                            );
                                        }}
                                        size="10"
                                        direction="left"
                                    />
                                </FlexWrapper>
                            }
                            leftSize={3}
                            centerSize={6}
                            rightSize={2}
                            alignLeft="center"
                            center={
                                <Headline white size="x2" align="center">
                                    {t.Shortcuts.selectGame}
                                </Headline>
                            }
                        />
                    )}

                    <ProductsShortcuts
                        onSelect={this.onProductSelectedHandler}
                        shortcutProducts={this.props.shortcutProducts}
                        VOnly={
                            (this.props.modalData &&
                                this.props.modalData.VOnly) ||
                            this.props.VOnly
                        }
                    />
                </Wrapper>
            );
        } else {
            return <Spinner size="x2" dark />;
        }
    }
}

const mapStateToProps = (state) => ({
    ready: !!state.AISDataProvider.raceDayData,
    shortcutProducts: getShortcutProducts(state),
});

const mapDispatchToProps = (dispatch) => {
    return {
        setProductShortcut: (product) => {
            dispatch(setProductShortcut(product));
        },
        fetchRaceDayCalendar: () => {
            dispatch(fetchRaceDayCalendar());
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProductsShortcutsContainer));
